import { render } from "./WalletWithdraw.vue?vue&type=template&id=abc178b2&scoped=true"
import script from "./WalletWithdraw.vue?vue&type=script&lang=js"
export * from "./WalletWithdraw.vue?vue&type=script&lang=js"

import "./WalletWithdraw.vue?vue&type=style&index=0&id=abc178b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc178b2"]])

export default __exports__